import circleIcon from "@/assets/leaflet/circleIcon";
import useMapMode from "@/services/store/useMapMode";
import { Box } from "@mui/material";
import L, { LatLngExpression } from "leaflet";
import { Marker } from "react-leaflet";

interface ILinesAndPoints {
  points: LatLngExpression[];
  color: string;
}

const LinesAndPoints: React.FC<ILinesAndPoints> = ({ points, color }) => {
  const mode = useMapMode((state) => state.mode);

  const customIcon = new L.Icon({
    iconUrl: circleIcon(color),
    iconSize: [14, 14],
  });

  if (mode !== "LINES_AND_POINTS") return null;
  return (
    <Box>
      {points
        ?.slice(0, -1)
        .map((point: LatLngExpression) => <Marker key={JSON.stringify(point)} position={point} icon={customIcon} />)}
    </Box>
  );
};

export default LinesAndPoints;
